module.exports = __webpack_public_path__ + "img/logo_wanchain.dc614b9a.png";